import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as systemconfigActions from '../systemconfig/redux/actions'
import { Input, Select } from 'antd'

import { Page, Crud } from '../../components'
const { Option } = Select;
const { CrudTable, CrudForm, CrudFilter, CrudButtons } = Crud

const state = [
  {
    id: 0,
    name: '进口'
  },
  {
    id: 1,
    name: '国产'
  }
]

export class Frui_qpfjPage extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    zzdwnolic: '',
    namejc: '',
    igasvID: '',
    jz: '',
  }
  componentDidMount() {
    const { frui_qpfjPage, currentFrui_qpfj } = this.props.user;
    const { getAllQppzList, getAllMakeUnitActions } = this.props.actions
    const { getDictionariesList } = this.props.systemconfigActions
    getDictionariesList()
    getAllQppzList()
    getAllMakeUnitActions()
    this.fetchList(frui_qpfjPage);
  }

  fetchList = (page, values) => {
    const { getFrui_qpfjList } = this.props.actions;
    let params = Object.assign({}, { page: page }, values)
    getFrui_qpfjList(params);
  }

  getDataSource() {
    const { user } = this.props;
    const { frui_qpfjById, frui_qpfjList } = user;
    if (!frui_qpfjList) return [];
    return frui_qpfjList.map(id => frui_qpfjById[id]);
  }
  get listProps() {
    const { user, actions } = this.props
    const { getFrui_qpfjListPending, frui_qpfjTotal, frui_qpfjPage } = user
    const { deleteFrui_qpfj, chooseCurrentFrui_qpfj, frui_qpfjModalChange } = actions;


    return {
      dataSource: this.getDataSource(),
      loading: getFrui_qpfjListPending,
      scroll: { x: 1300 },
      columns: [
        {
          title: "系统编号",
          dataIndex: 'bmQpfj',
          key: 'bmQpfj',
          width: 180,
        },
        {
          title: "规格",
          dataIndex: 'ggQpfj',
          key: 'ggQpfj',
          width: 180,
        },
        {
          title: "执行标准",
          dataIndex: 'gbinfo',
          key: 'gbinfo',
          width: 180,
        },
        {
          title: "制造单位编号",
          dataIndex: 'igasvID',
          key: 'igasvID',
          width: 180,
        },
        {
          title: "使用介质",
          dataIndex: 'jz',
          key: 'jz',
          width: 180,
        },
          {
          title: "型号",
          dataIndex: 'typeQpfj',
          key: 'typeQpfj',
          width: 180,
        },
        {
          title: "修改人",
          dataIndex: 'modifyBy',
          key: 'modifyBy',
          width: 180,
        },
        {
          title: "附件名称",
          dataIndex: 'nameQpfj',
          key: 'nameQpfj',
          width: 180,
        },
        {
          title: "别称",
          dataIndex: 'nameBc',
          key: 'nameBc',
          width: 180,
        },
        {
          title: "气瓶品种",
          dataIndex: 'qpCode',
          key: 'qpCode',
          width: 180,
        },
        {
          title: "制造单位简称",
          dataIndex: 'zzdwJcname',
          key: 'zzdwJcname',
          width: 180,
        },
        {
          title: "制造单位",
          dataIndex: 'zzdwName',
          key: 'zzdwName',
          width: 180,
        },
        {
          title: "制造单位证书",
          dataIndex: 'zzdwNoLic',
          key: 'zzdwNoLic',
          width: 180,
        },
      ],
      pagination: {
        total: frui_qpfjTotal,
        current: frui_qpfjPage,
        onChange: (page) => {
          this.fetchList(page);
        }
      },
      op: [
        {
          key: 1,
          name: '编辑',
          buttonProps: {
            icon: "edit",
            type: "primary"
          },
        },
        {
          key: 3,
          name: '删除',
          buttonProps: {
            icon: "delete",
            type: "danger"
          },
          needConfirm: true,
          confirmTitle: "确认删除"
        }
      ],
      handleMenuClick: (record, item) => {
        if (item.key == 1) {
          chooseCurrentFrui_qpfj(record);
          frui_qpfjModalChange(true, "updata");
        } else if (item.key == 3) {
          deleteFrui_qpfj(record.id).then((data) => {
            //  console.log(frui_qpfjTotal)
            this.fetchList();
          })
        }
      }
    }
  }

  // 制造单位
  gethandleMakeUnit = () => {
    const { getAllMakeUnitList, getAllMakeUnitId } = this.props.user
    return getAllMakeUnitList.map(id => getAllMakeUnitId[id]).map(item => (
      <Option key={item.name}>{item.name}</Option>
    ))
  }
  onChangeMakeUnit = (value) => {
    let arrValue = []
    arrValue.push(value)
    console.log(arrValue, 'arrValue')
    let object = {}
    const { getAllMakeUnitList, getAllMakeUnitId, } = this.props.user
    // 数组
    let MakeUnitList = getAllMakeUnitList.map(id => getAllMakeUnitId[id])
    // 把name值当成id hashMap，
    MakeUnitList.map(item => object[item.name] = item)
    // 找到之后赋值自动填充
    arrValue.map(item => object[item]).map(item => (
      this.setState({
        zzdwnolic: !item.noLic ? '' : item.noLic,
        igasvID: item.igasvID,
        namejc: item.nameJc
      })
    ))
  }

  // 附件名称
  gethandleFjname = () => {
    const { getgetDictionariesMap } = this.props.systemconfig;
    let arr = getgetDictionariesMap[12];
    if (arr) {
      return (arr.dictDetails).map(item => <Option key={item.value}>{item.value}</Option>)
    }
  }

  //  国别
  gethandleState = () => {
    return state.map(item => (
      <Option key={item.id}>{item.name}</Option>
    ))
  }

  // 气瓶品种
  gethandleBreed = () => {
    const { getAllQppzListId, getAllQppzList } = this.props.user
    return getAllQppzList.map(id => getAllQppzListId[id]).map(item => (
      <Option key={item.qpCode} >{`${item.qpName} ${item.qpCode}`}</Option>
    ))
  }
  handleChangeBreed = (res) => {
    let list = []
    list.push(res)
    const { getAllQppzListId, getAllQppzList } = this.props.user
    getAllQppzList.map(id => getAllQppzListId[id]).map(item => (
      this.setState({
        jz: item.jz
      })
    ))
  }

  get modalProps() {
    const { user, actions } = this.props
    const { currentFrui_qpfj, frui_qpfjModalVisible, frui_qpfjPage, frui_qpfjModalType, submitFrui_qpfjPending, } = user

    const { frui_qpfjModalChange, submitFrui_qpfj, chooseCurrentFrui_qpfj } = actions;
    // 固定的A10系统编号
    let Aten = ''
    const { getgetDictionariesMap } = this.props.systemconfig;
    let arr = getgetDictionariesMap[11];
    if (arr) {
      (arr.dictDetails).map(item => Aten = item.value)
    }
    const editItem = frui_qpfjModalType === 'create' ? {} : currentFrui_qpfj
    return {
      item: frui_qpfjModalType === 'create' ? {} : currentFrui_qpfj,
      visible: frui_qpfjModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitFrui_qpfjPending,
      title: `${
      frui_qpfjModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
          key: "bmQpfj",
          label: "系统编号",
          initialValue: editItem.bmQpfj,
          widget: Input,
          disabled: true
        },
        {
          key: "nameQpfj",
          label: "附件名称",
          initialValue: `${editItem.nameQpfj || ""}`,
          children: this.gethandleFjname(),
          widget: Select,
          required: true
        },
        {
          key: "zzdwName",
          label: "制造单位",
          initialValue: `${editItem.zzdwName || ""}`,
          widget: Select,
          children: this.gethandleMakeUnit(),
          required: true,
          widgetProps: {
            onChange: (res) => this.onChangeMakeUnit(res)
          }
        },
        {
          key: "igasvID",
          label: "制造单位编号",
          initialValue: this.state.igasvID || editItem.igasvID,
          widget: Input,
          required: true,
          disabled: true
        },
        {
          key: "zzdwJcname",
          label: "制造单位简称",
          initialValue: this.state.namejc || editItem.zzdwJcname,
          widget: Input,
          required: true,
          disabled: true
        },
        {
          key: "zzdwNoLic",
          label: "制造单位证书",
          initialValue: this.state.zzdwnolic || editItem.zzdwNoLic,
          widget: Input,
        },
          {
          key: "typeQpfj",
          label: "型号",
          initialValue: editItem.typeQpfj,
          widget: Input,
        },
        {
          key: "ggQpfj",
          label: "规格",
          initialValue: editItem.ggQpfj,
          widget: Input,
        },
        {
          key: "nameBc",
          label: "别称",
          initialValue: editItem.nameBc,
          widget: Input,
        },
        {
          key: "qpCode",
          label: "气瓶品种",
          initialValue: editItem.qpCode,
          widget: Select,
          widgetProps: {
            onChange: (res) => this.handleChangeBreed(res)
          },
          children: this.gethandleBreed(),
        },
        {
          key: "jz",
          label: "使用介质",
          initialValue: this.state.jz || editItem.jz,
          widget: Input,
          disabled: true
        },

        {
          key: "gbinfo",
          label: "执行标准",
          initialValue: editItem.gbinfo,
          widget: Input,
        },
        {
          key: "gb",
          label: "国别",
          children: this.gethandleState(),
          initialValue: `${editItem.gb || ""}`,
          widget: Select,
          required: true
        },
      ],
      onOk: data => {
        let params = {
          nameQpfj: data.nameQpfj,
          zzdwName: data.zzdwName,
          igasvID: data.igasvID,
          zzdwNoLic: data.zzdwNoLic,
          ggQpfj: data.ggQpfj,
          nameBc: data.nameBc,
          qpCode: data.qpCode,
          jz: data.jz,
          gbinfo: data.gbinfo,
          gb: data.gb,
          zzdwJcname: data.zzdwJcname,
          name: data.name,
          id: data.id,
          bmQpfj: Aten,
          typeQpfj:data.typeQpfj
        }
        submitFrui_qpfj(params).then(res => {
          console.log(data, res)
          frui_qpfjModalChange(false, "create");
          this.fetchList(frui_qpfjPage);
          chooseCurrentFrui_qpfj(data)
        })
          this.setState({
            igasvID: '',
            zzdwnolic: '',
            namejc: '',
            jz:''
          })
      },
      onCancel:() => {
          this.setState({
            igasvID: '',
            zzdwnolic: '',
            namejc: '',
            jz:''
          })
        frui_qpfjModalChange(false, "create");
      },
    }
  }

  get buttonProps() {
    const { actions, user } = this.props
    const { currentFrui_qpfj, frui_qpfjPage } = user
    const { frui_qpfjModalChange } = actions;

    return {
      buttons: [
        {
          name: "新增",
          buttonProps: {
            type: "primary",
            icon: "plus",
          },
          onClick: () => { frui_qpfjModalChange(true, 'create') }
        }
      ]
    }
  }

  render() {
    return (
      <Page inner>
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    user: state.user,
    systemconfig: state.systemconfig,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    systemconfigActions: bindActionCreators({ ...systemconfigActions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Frui_qpfjPage);


// WEBPACK FOOTER //
// ./src/features/user/Frui_qpfjPage.js